export default (params) => ({
  trigger: {
    name: 'order_block_summary.pick_up_in_store',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'pick_up_locations',
          'pick_up_button',
        ],
      },
    },
    event: {
      name: 'select_pickup',
    },
  },
});
